import moment from "moment-timezone";
import ScheduleSlotModel from "../api/models/ScheduleSlotModel";
import SessionModel from "../api/models/SessionModel";
import SizedStack from "../helpers/SizedStack";
import CalendarScheduleSlotModel from "../models/CalendarScheduleSlotModel";
import { ActiveSessionsService } from "./activeSessionsService";

export class CandidateScheduleService extends ActiveSessionsService {
  constructor(sessions: SessionModel[], scheduleSlots?: ScheduleSlotModel[]) {
    const weekStart = moment();
    const weekEnd = moment().add(7, "days");

    const currentWeekSlots =
      scheduleSlots
        ?.filter((slot) => {
          return slot.date?.isBetween(weekStart, weekEnd, "day", "[)");
        })
        ?.map((slot) => new CalendarScheduleSlotModel(slot)) || [];

    super(sessions, currentWeekSlots);
  }

  generateActiveSessions(sessionsCount = 2): SessionModel[] {
    let stack = new SizedStack<SessionModel>(sessionsCount);
    stack.push(...this.sessions.slice(-1 * sessionsCount));
    stack.push(...this.scheduleSlotsSessions.slice(0, sessionsCount - 1));

    const lastSession = this.sessions.at(-1);
    const restOfScheduledSessions = this.scheduleSlotsSessions.slice(
      sessionsCount - 1,
      sessionsCount
    );
    lastSession?.isInProgress
      ? stack.pushIfAvailable(...restOfScheduledSessions)
      : stack.push(...restOfScheduledSessions);

    return stack.asList;
  }
}
